import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';

import { ButtonText, SquaredButton, Title } from 'elements';
import { ContentSection } from 'components';
import QuestionForm from './components/QuestionForm';
import ReviewForm from './components/ReviewForm';
import ReviewListComponent from './components/ReviewsList';
import QuestionListComponent from './components/QuestionList';
import {
  RateButtonGroup,
  ReviewsSection,
  ReviewToggleWrapper,
  ReviewListWrapper,
  QuestionListWrapper,
  ReviewsAndQuestionsStyled,
} from './ReviewsAndQuestions.styled';

import scrollIntoView from 'utils/scrollIntoView';
import { productMap } from 'reduxState/userGenerated/userGenerated';
import { useContent } from 'utils/hooks';
import { REVIEWS_PAGE } from 'constants/contentful';

const ReviewsAndQuestions = ({ productId }) => {
  const reviewsContent = useContent(REVIEWS_PAGE);
  const [areQuestionsVisible, setAreQuestionsVisible] = useState(false);
  const [visibleForm, setVisibleForm] = useState('');
  const location = useLocation();

  const scrollRef = useCallback(
    (node) => {
      if (node && location) {
        scrollIntoView(location, node);
      }
    },
    [location]
  );

  const containerRef = useCallback(
    (node) => {
      if (node && location) {
        scrollIntoView(location, node);
      }
    },
    [location]
  );

  const handleTabChange = () => {
    setAreQuestionsVisible(!areQuestionsVisible);
  };
  const toggleVisibleForm = (type) => () => {
    if (type) {
      navigate(`${location.pathname}#review-form`); // needed to trigger scroll into view
    } else {
      // form submitted, close form section
      navigate(location.pathname);
    }
    setVisibleForm(type);
  };
  return (
    <ReviewsAndQuestionsStyled ref={containerRef} id='reviews-and-questions'>
      {!!productId && <Title modifiers='secondarySmall' content={reviewsContent?.[0]?.fields?.sections?.[0]?.fields?.title} />}
      <ContentSection>
        <RateButtonGroup>
          <SquaredButton label='WRITE A REVIEW' onClick={toggleVisibleForm('review')} />
          <SquaredButton label='ASK A QUESTION' onClick={toggleVisibleForm('question')} />
        </RateButtonGroup>
      </ContentSection>
      {!!visibleForm && (
        <ContentSection>
          <div ref={scrollRef} id='review-form'>
            <QuestionForm isVisible={visibleForm === 'question'} onSubmit={toggleVisibleForm('')} productId={productId} />
            <ReviewForm isVisible={visibleForm === 'review'} onSubmit={toggleVisibleForm('')} />
          </div>
        </ContentSection>
      )}
      <ContentSection>
        <ReviewsSection>
          <ReviewToggleWrapper>
            <ButtonText modifiers={['secondary', !areQuestionsVisible && 'underline']} label='Reviews' onClick={handleTabChange} />
            <ButtonText modifiers={['secondary', areQuestionsVisible && 'underline']} label='Questions' onClick={handleTabChange} />
          </ReviewToggleWrapper>
          <ReviewListWrapper>
            {areQuestionsVisible && (
              <QuestionListWrapper>
                <QuestionListComponent openQuestionForm={toggleVisibleForm('question')} productId={productId} />
              </QuestionListWrapper>
            )}
            {!areQuestionsVisible && <ReviewListComponent openReviewForm={toggleVisibleForm('review')} productId={productId} />}
          </ReviewListWrapper>
        </ReviewsSection>
      </ContentSection>
    </ReviewsAndQuestionsStyled>
  );
};

ReviewsAndQuestions.propTypes = {
  productId: PropTypes.oneOf(Object.keys(productMap)),
};

export default ReviewsAndQuestions;
